import * as auth from './auth.json';
import * as user from './user.json';
import * as base from './base.json';
import * as product from './product.json';
import * as order from './order.json';
import * as customer from './customer.json';
import * as wordboard from './wordboard.json';
import * as group from './group.json';

export default {
  auth,
  user,
  base,
  product,
  order,
  customer,
  wordboard,
  group,
};



// WEBPACK FOOTER //
// ./src/locale/th/index.js